import { browserTracingIntegration, captureException, init, replayIntegration } from "@sentry/vue"
import { formatComponentName, generateComponentTrace } from "../utils"

export default defineNuxtPlugin((nuxtApp) => {
	const router = useRouter()
	const config = useRuntimeConfig()

	if (!config.public.sentry.dsn) {
		console.warn("Sentry DSN not set, skipping Sentry initialization")
		return
	}

	nuxtApp.vueApp.config.errorHandler = undefined
	nuxtApp.hook("vue:error", (error, vm, lifecycleHook) => {
		const componentName = formatComponentName(vm, false)
		const trace = vm ? generateComponentTrace(vm) : ""
		const metadata = { componentName, lifecycleHook, trace }
		// @ts-expect-error Sentry Error
		metadata.propsData = vm.$props
		setTimeout(() => {
			captureException(error, {
				captureContext: { contexts: { vue: metadata } },
				mechanism: { handled: false },
			})
		})
	})

	init({
		app: nuxtApp.vueApp,
		dsn: config.public.sentry.dsn,
		integrations: [
			browserTracingIntegration({ router }),
			replayIntegration({
				maskAllText: false,
				blockAllMedia: false,
			}),
		],
		tracesSampleRate: 0.2,
		replaysSessionSampleRate: 1.0,
		replaysOnErrorSampleRate: 1.0,
	})
})
